import { render } from "./lockersModel.vue?vue&type=template&id=620020b2"
import script from "./lockersModel.vue?vue&type=script&lang=js"
export * from "./lockersModel.vue?vue&type=script&lang=js"

import "./lockersModel.vue?vue&type=style&index=0&id=620020b2&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__